import { useState } from 'react';
import CardPost from "./component/card-post";
import PracticeArea from "./component/practice-area";
import SEO from '../../components/seo';

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = date.getMonth() + 1; // Months are zero-based
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
};

export default function Practices(){
    const [latestDate, setLatestDate] = useState(null);

    const handleLatestDateUpdate = (date) => {
        setLatestDate(formatDate(date));
    };

    return(
        <div className="min-h-screen bg-[#090909] pb-16 text-zinc-300">
            <SEO
                title="Legal Services in Cebu City | Quilaton Law Office"
                description="Explore the legal practice areas of Quilaton Law Office, serving local and international clients from Cebu City, Philippines."
                path="/practices/"
            />
            <PracticeArea/>
            <div className="mt-20 flex flex-col items-center">
                <div className="flex w-full max-w-7xl items-end justify-between border-b border-zinc-700/80 px-5 pb-6 lg:px-10">
                    <h2 className="font-fontMontserrat text-4xl text-zinc-100">Recent Posts</h2>
                    <p className="font-mono text-xs tracking-[0.12em] text-zinc-500">Last updated {latestDate}</p>
                </div>
                <CardPost onLatestUpdate={handleLatestDateUpdate}/>
            </div>
        </div>
    )
}
